import type { PixelRuntimeContext } from '@/runtime/PixelRuntimeContext';

export class FingerprintEngine {
  private readonly context: PixelRuntimeContext;

  constructor(context: PixelRuntimeContext) {
    this.context = context;
  }

  init(): void {
    if (!this.context.config.modules.core.fingerprint.enabled) return;

    this.context.logger.debug('[FingerprintEngine] Ensuring fingerprint');
    this.context.services.fingerprint.ensureFingerprint();
  }

  destroy(): void {}
}
